<template>
  <div class="card col-lg-12 p-0">
    <div class="card-body">
      <h3 class="font-600">Incomplete Teleconsult Answers</h3>
      <p class="f-14 mb-2">Fix missing answers on a teleconsult</p>
      <form @submit.prevent="submit">
        <ValidationObserver class="card-content" ref="userObserver">
          <div class="row">
            <ValidationProvider
              name="User Email"
              v-slot="{ errors }"
              rules="email|required"
              class="col-6"
            >
              <div
                class="form-group"
                :class="{ 'validation-warning': errors[0] }"
              >
                <label class="required">User Email</label>
                <input
                  type="text"
                  v-model="email"
                  class="form-control"
                  placeholder="Enter User Email"
                />
                <small class="text-danger" v-if="errors[0]">
                  {{ errors[0] }}
                </small>
              </div>
            </ValidationProvider>
          </div>
        </ValidationObserver>
        <div class="row">
          <div class="text-left col">
            <button
              class="btn btn-primary float-left"
              :disabled="isSearchLoading"
              @click="handleSearchUser"
            >
              <div v-if="isSearchLoading">
                Loading<i class="fa fa-spinner fa-spin"></i>
              </div>
              <div v-else>Search</div>
            </button>
          </div>
        </div>
        <hr v-if="isAnswerShown" />
        <ValidationObserver
          class="card-content"
          ref="answersObserver"
          v-if="isAnswerShown"
        >
          <div class="row">
            <ValidationProvider
              name="Consult ID"
              v-slot="{ errors }"
              rules="required"
              class="col-6"
            >
              <div
                class="form-group"
                :class="{ 'validation-warning': errors[0] }"
              >
                <label class="required">Consult ID</label>
                <input
                  type="text"
                  v-model="consultId"
                  class="form-control"
                  placeholder="Enter Consult ID"
                />
                <small class="text-danger" v-if="errors[0]">
                  {{ errors[0] }}
                </small>
              </div>
            </ValidationProvider>
          </div>
          <p class="f-16 mb-2 font-500">Answers</p>
          <div class="row mb-1">
            <div class="col-1 font-500 text-center">Select</div>
            <div class="col-2 font-500 text-center">Consult ID</div>
            <div class="col font-500">Content Title</div>
          </div>
          <div v-for="(answer, idx) in answers" :key="idx" class="row mb-1">
            <div class="col-1">
              <div class="form-group text-center">
                <input type="checkbox" v-model="answer.isSelected" />
              </div>
            </div>
            <div class="col-2">
              <p class="text-center">{{ answer.consult ? answer.consult.consultId : '-' }}</p>
            </div>
            <div class="col">{{ answer.content.title }}</div>
          </div>
        </ValidationObserver>
        <div v-if="isAnswerShown" class="text-left mt-4">
          <button
            type="submit"
            class="btn btn-primary float-left"
            :disabled="isSubmitLoading"
          >
            <div v-if="isSubmitLoading">
              Loading<i class="fa fa-spinner fa-spin"></i>
            </div>
            <div v-else>Submit</div>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      userId: null,
      consultId: '',
      answers: [],
      isSearchLoading: false,
      isSubmitLoading: false,
    };
  },
  computed: {
    isAnswerShown() {
      return this.answers.length > 0;
    },
  },
  methods: {
    async resetData() {
      this.email = '';
      this.userId = null;
      this.consultId = '';
      this.answers = [];
      await this.$refs.userObserver.reset();
    },
    getUserAnswers(userId) {
      this.axios
        .get(`/devs/users/${userId}/answers`)
        .then((resp) => {
          this.answers = resp.data.data.map((answer) => ({
            ...answer,
            isSelected: false,
          }));
        })
        .catch((err) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: err.response.data.message,
          });
        })
        .finally(() => {
          this.isSearchLoading = false;
        });
    },
    async handleSearchUser() {
      const isValid = await this.$refs.userObserver.validate();
      if (isValid) {
        this.isSearchLoading = true;

        this.axios
          .get('/v2/users', {
            params: {
              limit: 1,
              email: this.email,
            },
          })
          .then((resp) => {
            if (resp.data.data.rows && resp.data.data.rows.length > 0) {
              this.getUserAnswers(resp.data.data.rows[0].id);
            } else {
              this.$notify({
                type: 'error',
                title: 'Error',
                text: 'User not found',
              });
              this.isSearchLoading = false;
            }
          })
          .catch((err) => {
            this.$notify({
              type: 'error',
              title: 'Error',
              text: err.response.data.message,
            });
            this.isSearchLoading = false;
          });
      }
    },
    async submit() {
      const isValid = await this.$refs.answersObserver.validate();
      if (isValid) {
        this.isSubmitLoading = true;

        const payload = {
          consultId: this.consultId,
          answerIds: this.answers
            .filter((answer) => answer.isSelected)
            .map((answer) => answer.id),
        };

        this.axios
          .post('/devs/consults/move-answers', payload)
          .then((resp) => {
            this.$notify({
              type: 'success',
              title: 'Success!',
              text: resp.data.message,
            });
            this.resetData();
          })
          .catch((err) => {
            this.$notify({
              type: 'error',
              title: 'Error',
              text: err.response.data.message,
            });
          })
          .finally(() => {
            this.isSubmitLoading = false;
          });
      }
    },
  },
};
</script>
